export enum MeasureUnitType {
    Divisa = 1,
    Energía = 2,
    Volumen = 3,
    Presión = 4,
    Tiempo = 5,
    Potencia = 6,
    Otros = 7,
    Temperatura = 8
}